export const useRedirect = () => {
  const redirectTo = (url: string) => {
    // if (isEmbedded) {
    // const redirect = Redirect.create(appBridge);
    // redirect.replaceTo(url);
    // } else {
    window.open(url, '_blank');
    // }
  };

  return { redirectTo };
};
